import { useState, useEffect } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';
import useBackendApi from '../hooks/useBackendApi';
import { colors } from '../styles/fontStyles';
import PrimaryBlueButton from '../components/common/buttons/PrimaryBlueButton';
import MediaCarousel from '../shop/MediaCarousel';
import { CarouselElement } from '../types/shop';
import { UNAUTHENTICATED } from '../constants/user';
import FrostGuestHome from '../frost/FrostGuestHome';
import FrostAuthHome from '../frost/FrostAuthHome';

const backendURL = process.env.REACT_APP_BACKEND_URL;

const FrostHome = () => {
  const { theme, userType } = useThemeContext();
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [appointmentDetails, setAppointmentDetails] = useState<{ date: string; time: string } | null>(null);
  const [apptDetailsNotFound, setApptDetailsNotFound] = useState(true);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(true);
  const [frostHomepageMedia, setFrostHomepageMedia] = useState<CarouselElement[]>([]);

  const { apiFetchRequest } = useBackendApi();

  return (userType === UNAUTHENTICATED ? <FrostGuestHome /> : <FrostAuthHome />);
};

export default FrostHome;
